import React from "react";
import { motion } from "framer-motion";
import { ourCapability } from "../Data";

const OurNetwork = () => {
  return (
    <section className="capability-section">
      {/* SECTION TITLE */}
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        Our Network & Operational Capability
      </motion.h2>

      {/* CARDS */}
      <motion.div
        className="capability-grid"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.12
            }
          }
        }}
      >
        {ourCapability.map((item, index) => (
          <motion.div
            className="capability-card"
            key={index}
            variants={{
              hidden: { opacity: 0, y: 25 },
              visible: {
                opacity: 1,
                y: 0,
                transition: { duration: 0.45, ease: "easeOut" }
              }
            }}
            whileHover={{ scale: 1.03 }}
          >
            <p>{item.text}</p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default OurNetwork;
